/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/ainvoice'
export default icon
